import client from './client';

export type ReportInput = {
    targetType: 'POST' | 'COMMENT';
    targetId: number;
    reason: 'SPAM' | 'ABUSE' | 'FALSE_INFORMATION' | 'OTHER';
    detail: string;
};

export const createReport = async (report: ReportInput): Promise<void> => {
    await client.post('/reports', report);
};
